<template>
    <div class="list-wrap">
        <div class="features-wrapper">
            <FeatureEditor
                v-if="selectedFeature"
                :selectedFeature="selectedFeature"
                :isNewFeature="isNewFeature"
                @cancel="exitEditor"
            />

            <FeatureList
                v-else
                @edit="editEntity"
                @create="createNewEntity"
            />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import FeatureList from './list/FeatureList'
import FeatureEditor, { getDefaultFeature } from './editor/FeatureEditor'

export default {
  name: 'FeaturesTab',
  components: {
    FeatureList,
    FeatureEditor
  },

  mounted () {
    this.fetchFeatures()
  },

  data () {
    return {
      selectedFeature: null,
      isNewFeature: false
    }
  },

  methods: {
    ...mapActions('knowledgebase/features', ['fetchFeatures']),

    createNewEntity () {
      this.isNewFeature = true
      this.selectedFeature = getDefaultFeature()
    },

    editEntity (selectedFeature) {
      this.isNewFeature = false
      this.selectedFeature = selectedFeature
    },

    exitEditor () {
      this.selectedFeature = null
      this.isNewFeature = false
    }
  }

}
</script>

<style scoped lang="scss">
    .list-wrap {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        .features-wrapper {
            display: flex;
            height: 100%;
            flex-direction: column;
            padding: 0 $sp-3;
        }
    }
</style>
